import React, { useState, useEffect } from "react";
import { Upload, RefreshCw } from "lucide-react";
import "./EmailHeaderImage.css";
import BaseButton from "../Common/BaseButton";

const EmailHeaderImage = ({ id, initialHeroImage = {}, onHeroImageChange, onUpdate, data }) => {
  
  // Handle image data in different formats
  const defaultImage =
    typeof initialHeroImage === "string"
      ? initialHeroImage
      : initialHeroImage?.heroImg || "";

  const [heroImage, setHeroImage] = useState(defaultImage);

  // Update local state when props change
  useEffect(() => {
    const newDefaultImage = 
      typeof initialHeroImage === "string"
        ? initialHeroImage
        : initialHeroImage?.heroImg || "";
    
    if (newDefaultImage !== heroImage) {
      setHeroImage(newDefaultImage);
    }
  }, [initialHeroImage]);

  // Return nothing if no hero image is defined and this is being used in a conditional way
  if (!initialHeroImage?.heroImg && typeof initialHeroImage !== "string" && !data?.heroImg) {
    return null;
  }

  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const imageDataUrl = reader.result;

      // Update local state
      setHeroImage(imageDataUrl);
      
      // Update parent component using all available methods
      if (onHeroImageChange) {
        onHeroImageChange(imageDataUrl);
      }
      
      // If this is used inside an email section component that has onUpdate
      if (onUpdate) {
        onUpdate({
          ...data,
          heroImg: imageDataUrl,
          component_name: data?.component_name || "Header"
        }, id);
      }
    };

    reader.readAsDataURL(file);
  };

  const regenerateImage = () => {
    console.log("Regenerating hero image");
    // Implementation for regenerating would go here
  };

  return (
    <div className="product-image-container">
      <div className="row">
        <div className="col-12 mb-4">
          <div className="section">
            <div className="section-header">
              <h2>Email Header Image</h2>
              <div className="button-group">
                <BaseButton
                  className="outlineprimary"
                  children="Regenerate Image"
                  imageSrc="/regenerate-image.svg"
                  handleClick={regenerateImage}
                />
                <label className="btn btn-outline-danger">
                  <Upload size={16} />
                  Upload Image
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, "hero")}
                  />
                </label>
              </div>
            </div>

            <div className="image-preview hero-image">
              {heroImage ? (
                <img 
                  src={heroImage} 
                  alt="Hero Image" 
                  onError={(e) => {
                    console.error("Image failed to load:", heroImage);
                    e.target.onerror = null; 
                    e.target.src = "https://via.placeholder.com/800x200/f8f9fa/6c757d?text=Header+Image";
                  }}
                />
              ) : (
                <div className="placeholder-image d-flex align-items-center justify-content-center bg-light rounded" style={{ height: "150px" }}>
                  <span className="text-muted">Upload a header image</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailHeaderImage;
